import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const ForgetPassword = () => {
 return (
  <AuthCardLayout>
   <h4 className="mb-0"> Olvido su Contraseña?</h4>
   <p className="mb-0">Ingrese su Email en el que le enviaremos un link.</p>
   <ForgetPasswordForm layout="card" />
  </AuthCardLayout>
 );
};

export default ForgetPassword;
